var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeTimeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stopwatch_3w",
    clipPath: "url(#clip0_1064_1187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.888 18.1289C29.888 25.7865 23.68 31.9956 16.0213 31.9956C8.36266 31.9956 2.15466 25.7865 2.15466 18.1289C2.15466 10.8308 7.79626 4.86281 14.9547 4.31561V2.12894H13.888V-0.00439453H18.1547V2.12894H17.088V4.31561C20.2219 4.55561 23.0645 5.83347 25.2704 7.80681L26.688 6.38921L28.8213 8.52894L27.2832 10.0671C28.9141 12.3401 29.888 15.1156 29.888 18.1289ZM16.0213 6.39667C9.54133 6.39667 4.288 11.65 4.288 18.13C4.288 24.61 9.54133 29.8623 16.0213 29.8623C22.5013 29.8623 27.7547 24.61 27.7547 18.13C27.7547 11.6489 22.5013 6.39667 16.0213 6.39667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2667 18.1334C14.2667 16.9558 15.2224 16.0001 16.4 16.0001C17.5776 16.0001 18.5333 16.9558 18.5333 18.1334C18.5333 19.311 17.5776 20.2668 16.4 20.2668L11.0667 25.6001L9.99999 24.5334L14.304 18.5078C14.2837 18.3841 14.2667 18.2614 14.2667 18.1334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_1187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeTimeActive);
export default __webpack_public_path__ + "static/media/largeTimeActive.65e06c025fb06882125ce3438412c522.svg";
export { ForwardRef as ReactComponent };